/**
 * Joins url parts with a single slash, preserving the double slash of a scheme.
 * Empty or nullish parts are skipped.
 */
export const joinUrl = (...parts: (string | null | undefined)[]): string =>
  parts
    .filter((part): part is string => !!part)
    .map((part, index) =>
      index === 0
        ? part.replace(/\/+$/, '')
        : part.replace(/^\/+/, '').replace(/\/+$/, '')
    )
    .filter((part) => part !== '')
    .join('/');
